import { useCallback, useEffect, useState } from "react";

const KEY = "fora_theme";

const initial = () => {
  try {
    // display links can carry ?theme=dark – the URL wins and is remembered on the device
    const q = new URLSearchParams(window.location.search).get("theme");
    if (q === "dark" || q === "light") {
      localStorage.setItem(KEY, q);
      return q;
    }
    return localStorage.getItem(KEY) === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
};

/** Board-only theme: "light" (default) or "dark"; the `dark` class goes on <html> while the board is mounted
 *  so portaled dialogs/toasts follow, and is removed on unmount (Admin always stays light). */
export function useTheme() {
  const [theme, setTheme] = useState(initial);
  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    return () => document.documentElement.classList.remove("dark");
  }, [theme]);
  const toggle = useCallback(() => {
    setTheme((t) => {
      const next = t === "dark" ? "light" : "dark";
      try {
        localStorage.setItem(KEY, next);
      } catch {
        /* ignore */
      }
      return next;
    });
  }, []);
  return { theme, dark: theme === "dark", toggle };
}
